import { NgModule } from '@angular/core';
import { BasePanelComponent } from './pages/base-panel/base-panel.component';
import { BaseHeaderComponent } from './pages/base-panel/components/base-header/base-header.component';
import { SharedModule } from '@shared/shared.module';
import { RouterModule } from '@angular/router';
import { BaseAvatarSettingsComponent } from './pages/base-panel/components/base-avatar-settings/base-avatar-settings.component';
import { BaseLogoComponent } from './pages/base-panel/components/base-logo/base-logo.component';
import { BasePanelCanActivateGuard } from '@modules/base-panel/guards/base-panel-can-activate.guard';
import { BaseLeftSideNavigationComponent } from './pages/base-panel/components/base-left-side-navigation/base-left-side-navigation.component';
import { BaseLeftSideNavigationMenuComponent } from './pages/base-panel/components/base-left-side-navigation/components/base-left-side-navigation-menu/base-left-side-navigation-menu.component';
import { BaseLeftSideNavigationFooterComponent } from './pages/base-panel/components/base-left-side-navigation/components/base-left-side-navigation-footer/base-left-side-navigation-footer.component';
import { BaseNavLinkComponent } from './pages/base-panel/components/base-nav-link/base-nav-link.component';
import { BaseLeftSideNavigationFooterUserComponent } from './pages/base-panel/components/base-left-side-navigation/components/base-left-side-navigation-footer/components/base-left-side-navigation-footer-user/base-left-side-navigation-footer-user.component';
import { GetResponseChatComponent } from './pages/base-panel/components/get-response-chat/get-response-chat.component';
import { BaseNavFunnelComponent } from './pages/base-panel/components/base-left-side-navigation/components/base-left-side-navigation-menu/components/base-nav-funnel/base-nav-funnel.component';
import { UserFunnelsListService } from '@modules/base-panel/pages/base-panel/services/user-funnels-list.service';
import { WelcomeBannerComponent } from './shared/components/welcome-banner/welcome-banner.component';
import { UserCreditsBadgeComponent } from './pages/base-panel/components/base-left-side-navigation/components/base-left-side-navigation-footer/components/base-left-side-navigation-footer-user/component/user-credits-badge/user-credits-badge.component';
import { BaseOnboardingLoadingComponent } from './pages/base-panel/components/base-onboarding-loading/base-onboarding-loading.component';
import { PanelRoutes } from '@core/routes/configs/panel.routes';

@NgModule({
  declarations: [
    BasePanelComponent,
    BaseHeaderComponent,
    BaseAvatarSettingsComponent,
    BaseLogoComponent,
    BaseLeftSideNavigationComponent,
    BaseLeftSideNavigationMenuComponent,
    BaseLeftSideNavigationFooterComponent,
    BaseNavLinkComponent,
    BaseLeftSideNavigationFooterUserComponent,
    GetResponseChatComponent,
    BaseNavFunnelComponent,
    WelcomeBannerComponent,
    UserCreditsBadgeComponent,
    BaseOnboardingLoadingComponent,
  ],
  imports: [SharedModule, RouterModule.forChild(PanelRoutes)],
  providers: [BasePanelCanActivateGuard, UserFunnelsListService],
})
export class BasePanelModule {}
